import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config';

const HelmetWrapper = ({ title, description, urlPath, image, parentUrl, parentTitle }) => {
  const seoUrl = `${config.hostForSEO}${urlPath}`;
  const url = `${config.surflineHost}${urlPath}`;
  const link = [
    {
      rel: 'canonical',
      href: seoUrl,
    },
  ];
  if (parentUrl && parentTitle) {
    link.push({
      rel: 'start',
      href: `${config.hostForSEO}${parentUrl}`,
      title: parentTitle,
    });
  }

  const meta = [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:url',
      content: url,
    },
    {
      property: 'og:image',
      content: image,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'twitter:title',
      content: title,
    },
    {
      property: 'twitter:url',
      content: url,
    },
    {
      property: 'twitter:image',
      content: image,
    },
    {
      property: 'twitter:description',
      content: description,
    },
  ];

  const robotsMeta = config.robots
    ? {
        name: 'robots',
        content: config.robots,
      }
    : null;

  if (robotsMeta) {
    meta.push(robotsMeta);
  }

  return <Helmet title={title} meta={meta} link={link} />;
};

HelmetWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  urlPath: PropTypes.string.isRequired,
  image: PropTypes.string,
  parentUrl: PropTypes.string,
  parentTitle: PropTypes.string,
};

HelmetWrapper.defaultProps = {
  image: config.facebookOGImage,
  parentUrl: null,
  parentTitle: null,
};

export default HelmetWrapper;
